module.exports = __webpack_public_path__ + "./images/963278b54e9593887753d96a7493daf4.webp";